import type { TPassportFormFields } from 'src/client/entities/creditForm';

export const PassportInfoTexts: Record<keyof TPassportFormFields, string> = {
  fullName: 'ФИО',
  gender: 'пол',
  birthDate: 'Дата рождения',
  birthPlace: 'Место рождения',
  passportNumber: 'Серия и номер паспорта',
  passportIssueDate: 'Дата выдачи',
  passportIssuedBy: 'Кем выдан',
  unitCode: 'Код подразделения',
  registrationAddress: 'Населенный пункт, улица, дом',
  registrationLocationRoute: 'route адреса регистрации',
  registrationAddressFlat: 'Квартира',
  registrationDate: 'Дата регистрации',
  residenceAddress: 'Населенный пункт, улица, дом',
  residenceLocationRoute: 'route адреса проживания',
  residenceAddressFlat: 'Квартира',
  residenceAddressIsRegistration: 'Адрес фактического проживания совпадает с адресом регистрации',
  region: 'Название города',
  regionLocationRoute: 'route города получения кредита',
  regionLocation: 'Город получения кредита',
};

export const PassportInfoModalTexts = {
  title: 'Паспортные данные',
  description: 'Проверьте, что всё верно, и внесите изменения',
};

export const PassportInfoHintTexts = {
  passportIssuedBy:
    'Название подразделения должно точно совпадать с данными в паспорте — выберите нужный вариант из списка',
  birthPlace: 'Укажите как в паспорте',
};
